<!--<div id="spinner" class="spinner" *ngIf="commonService.load === true">-->
<!--  <div  class="lds-ring">-->
<!--    <img class="loader-img" alt="logo">-->
<!--    <h2 style="color: white;">Loading data ...</h2>-->
<!--    <div></div><div></div><div></div><div></div></div>-->
<!--</div>-->
<router-outlet></router-outlet>
